import { AppStatus, useAppSelector } from '@/redux'
import { analytics } from '@/services/analytics/segment'
import { ReviewOrganisationModal } from '../Pulse/components'
import { Organisation } from '@/features'
import { ensureProfileCompletion } from '@/features/Auth/session/ensureProfileCompletion'

export async function handleOnboardingValidations(bypass = false) {
  if (bypass) return

  await ensureProfileCompletion(true)
}

export function useAct() {
  const { available } = Organisation.Pulse.usePulseQuestions()

  async function onPressOrganisation(bypass = false) {
    await handleOnboardingValidations(bypass)

    if (!available) {
      AppStatus.setModal('noReviewQuestions')
      return
    }

    ReviewOrganisationModal.toggle()
  }

  async function onPressStories(bypass = false) {
    await handleOnboardingValidations(bypass)

    analytics.track('story_add_start', { source_from: 'act' })
    AppStatus.setModal('createStory')
  }

  const abortedAction = useAppSelector(s => s.Session.abortedAction)
  const hasAbortedAction = ['stories', 'review'].includes(abortedAction)

  const handleAbortedAction = async () => {
    if (!hasAbortedAction) return
    if (abortedAction === 'stories') {
      onPressStories(true)
    } else {
      onPressOrganisation(true)
    }
  }

  return {
    onPressOrganisation,
    onPressStories,
    handleAbortedAction,
    hasAbortedAction
  }
}
